import { render, staticRenderFns } from "./NoMoreData.vue?vue&type=template&id=75540fc4&scoped=true"
import script from "./NoMoreData.vue?vue&type=script&lang=js"
export * from "./NoMoreData.vue?vue&type=script&lang=js"
import style0 from "./NoMoreData.vue?vue&type=style&index=0&id=75540fc4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75540fc4",
  null
  
)

export default component.exports